import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
const SvgLucideEllipsisVertical = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <g
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    >
      <circle cx={12} cy={12} r={1} />
      <circle cx={12} cy={5} r={1} />
      <circle cx={12} cy={19} r={1} />
    </g>
  </svg>
);
const ForwardRef = forwardRef(SvgLucideEllipsisVertical);
const Memo = memo(ForwardRef);
export default Memo;
